import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import { propTypes, defaultProps } from '../prop-types';
import Avatar from '../../shared/avatar';

const Container = styled.section`
  border: none;
  padding: 0;
  display: flex;

  & > *:first-child {
    flex-shrink: 0;
  }

  & > .v-flex {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
`;

const Name = styled.a`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  :hover {
    text-decoration: none;
  }

  & > span {
    color: ${props => dt(props).theme.bodyColor};
    font: ${props => dt(props).theme.fontWeightDccc} 20px/24px ${props => dt(props).theme.fontFamilyBody};
    text-transform: uppercase;
    > u {
      text-decoration: none;
      border-bottom: 1px solid ${props => dt(props).theme.bodyColor};
    }
  }

  & > .fa-chevron-up {
    color: ${props => dt(props).theme.primaryColor};
    transform: rotate(90deg);
    font-size: 14px;
    margin-bottom: 10px;
  }
`;

const Title = styled.span`
  font: ${props => dt(props).theme.fontWeightRegular} 14px/16.8px ${props => dt(props).theme.fontFamilyBody};
  color: ${props => dt(props).theme.bodyColor};
`;

const Org = styled.span`
  margin-top: 5px;
  font: ${props => dt(props).theme.fontWeightHeavy} 16px/19.2px ${props => dt(props).theme.fontFamilyBody};
  color: ${props => dt(props).theme.secondaryColor};
`;

export default function Contributor(props) {
  const { profile, clickDataAttributes } = props;

  return (
    <Container>
      <Avatar {...{ ...profile, clickDataAttributes }} />
      <div className="v-flex">
        <Name href={`/contributors/${profile.slug}`}>
          <span>
            <u>{profile.name}</u>
          </span>
          <i className="fa fa-chevron-up" />
        </Name>
        <Title>{profile.position}</Title>
        <Org>{profile.organisation}</Org>
      </div>
    </Container>
  );
}

Contributor.propTypes = propTypes;
Contributor.defaultProps = defaultProps;
